var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasContainerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 15C16.25 14.0054 16.6451 13.0516 17.3483 12.3483C18.0516 11.6451 19.0054 11.25 20 11.25C20.9946 11.25 21.9484 11.6451 22.6517 12.3483C23.3549 13.0516 23.75 14.0054 23.75 15V31.75C23.75 31.8485 23.7306 31.946 23.6929 32.037C23.6552 32.128 23.6 32.2107 23.5303 32.2803C23.4607 32.35 23.378 32.4052 23.287 32.4429C23.196 32.4806 23.0985 32.5 23 32.5H17C16.9015 32.5 16.804 32.4806 16.713 32.4429C16.622 32.4052 16.5393 32.35 16.4697 32.2803C16.4 32.2107 16.3448 32.128 16.3071 32.037C16.2694 31.946 16.25 31.8485 16.25 31.75V15ZM16.25 18.75H20H23.75M20 11.25V7.5V11.25ZM20 7.5H18.75H20ZM20 7.5H21.25H20Z",
    fill: "#ECB32C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.25C19.0054 11.25 18.0516 11.6451 17.3483 12.3483C16.6451 13.0516 16.25 14.0054 16.25 15V31.75C16.25 31.8485 16.2694 31.946 16.3071 32.037C16.3448 32.128 16.4 32.2107 16.4697 32.2803C16.5393 32.35 16.622 32.4052 16.713 32.4429C16.804 32.4806 16.9015 32.5 17 32.5H23C23.0985 32.5 23.196 32.4806 23.287 32.4429C23.378 32.4052 23.4607 32.35 23.5303 32.2803C23.6 32.2107 23.6552 32.128 23.6929 32.037C23.7306 31.946 23.75 31.8485 23.75 31.75V15C23.75 14.0054 23.3549 13.0516 22.6517 12.3483C21.9484 11.6451 20.9946 11.25 20 11.25ZM20 11.25V7.5M16.25 18.75H20H23.75M20 7.5H18.75M20 7.5H21.25",
    stroke: "#ECB32C",
    strokeOpacity: 0.3,
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ECB32C",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasContainerIcon);
export default __webpack_public_path__ + "static/media/gas-container-icon.7979b9fb336e305ad6fff59232c318cd.svg";
export { ForwardRef as ReactComponent };